// components/common/formbuilder/XPPopup.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const XPPopup = ({ xp, isVisible, position = 'top-right' }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ 
            scale: 0.8, 
            opacity: 0, 
            x: 20, 
            y: -20 
          }}
          animate={{ 
            scale: 1, 
            opacity: 1, 
            x: 0, 
            y: 0,
            transition: {
              type: "spring",
              stiffness: 500,
              damping: 25
            }
          }}
          exit={{ 
            scale: 0.8, 
            opacity: 0, 
            x: 20, 
            y: -20,
            transition: {
              duration: 0.2
            }
          }}
          className="absolute top-4 right-4 z-10"
        >
          <motion.div
            className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-full border-2 border-yellow-300"
            whileHover={{ scale: 1.05 }}
          >
            <div className="flex items-center gap-2 font-bold text-sm">
              <span className="text-yellow-200">⭐</span>
              <span>+{xp} XP</span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default XPPopup;